// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from '../../../store/store';

import { fetchEquipmentDetails } from '../../../store/equipment/equipmentActions';

// Prevent multiple simultaneous loads during launch (shouldRevalidate takes
// care of it after that)
let isFetching = false;

export async function equipmentControlLoader({ params }) {
  const { equipmentGroupId, cameraId } = params;

  if (!equipmentGroupId || !cameraId) {
    return null;
  }

  if (isFetching) {
    return null;
  }

  // get company uuid
  const state = store.getState();
  const companyUuid = state.companies?.company?.company_uuid;

  if (!companyUuid) {
    return null;
  }

  isFetching = true;
  // Fetch equipmen details on switching PTZ in the group navigation
  await store.dispatch(fetchEquipmentDetails({ companyUuid, equipUUID: cameraId }));

  isFetching = false;
  return null;
}

equipmentControlLoader.hydrate = true;
